import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAdminData } from "../actions/adminActions";
import Loader from "./Loader";
import Sidebar from "./Sidebar";

// Gates every protected route: no token in localStorage (mirrored into
// adminLogin.admin at store init) sends the user straight to /login before
// anything protected renders. A token with no cached profile yet (fresh
// reload) triggers a fetch and shows a loader instead of flashing protected
// UI or bouncing through /login the way the old per-screen Sidebar check did.
const RequireAuth = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const adminLogin = useSelector((state) => state.adminLogin);
  const { admin } = adminLogin || {};

  const adminInfo = useSelector((state) => state.adminInfo);
  const { adminData, error: adminDataError } = adminInfo || {};

  useEffect(() => {
    if (admin?.token && !adminData) {
      dispatch(getAdminData());
    }
  }, [admin, adminData, dispatch]);

  if (!admin?.token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminDataError) {
    return <Navigate to="/login" replace />;
  }

  if (!adminData) {
    // Render the real layout immediately (sidebar visible right away)
    // instead of a blank full-page loader — only the content area waits.
    return (
      <div className="container-fluid ps-0">
        <div className="row">
          <div className="col-lg-2">
            <Sidebar />
          </div>
          <div className="col-lg-10 p-0" style={{ height: "100vh" }}>
            <Loader />
          </div>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default RequireAuth;
